import { ProvisionItemDescriptionMap } from "./provisionitemdescriptionmap";

export class ProvisionItemDescription {

    Family: string;
    Execution: string;
    FamilyDescription: string;
    ExecutionDescription: string;

    constructor(family?: string, familyDescription?: string, execution?: string, executionDescription?: string) {
        this.Family = family;
        this.FamilyDescription = familyDescription;
        this.Execution = execution;
        this.ExecutionDescription = executionDescription
    }
    static toMap(items : ProvisionItemDescription[]){     
        let map: ProvisionItemDescriptionMap = { };
        items.forEach(item => {
            map[item.Family] = item;
        })
        return map;
    }
}
